module.exports = __webpack_public_path__ + "img/Yarn.2a92b07b.png";